<template>
<follower-page-data></follower-page-data>
</template>
<script>
import followerPageData from "cps/follower-page/withData";
export default {
  components: {
    followerPageData,
  },
}
</script>